import Vue from 'vue'

const Users = {
  namespaced: true,

  state: {
    user: {},
    userName: null,
    users: []
  },

  mutations: {
    setUsers(state, users) {
      state.users = users || []
    },
    setUser(state, user) {
      state.user = user || {}
      state.userName = `${state.user.firstname} ${state.user.lastname}`
    }
  },

  actions: {
    async getAll({ commit }, { search } = {}) {
      const params = { search }
      const response = await Vue.axios.get('/users', { params })
      const users = response.data.data
      commit('setUsers', users)
      return users
    },
    async get({ commit }, id) {
      let user = {}
      if (id) {
        const response = await Vue.axios.get(`/user/${id}`)
        user = response.data.data
      }
      commit('setUser', user)
      return user
    },
    async createOrUpdate({ commit, state }) {
      let response
      if (state.user.id) {
        response = await Vue.axios.put(`/user/${state.user.id}`, state.user)
      } else {
        response = await Vue.axios.post('/user', state.user)
      }
      commit('setUser', response.data.data)
    }
  }
}

export default Users
